export default __webpack_public_path__ + "static/media/DNo.4-3.5a14089e.jpg";